import React from "react";
import {AppButton} from "../../../styles/Butttons";
import Modal from "../../../containers/Modal";
import {Input, SelectStyled, TextArea} from "../../../styles/Forms";
import {Grid, Col} from "../../../styles/Grid";
import styled from "styled-components";
// import {ReactComponent as PlusIcon} from "../../../assets/icons/plus.svg";
import {Label} from "../../../components/forms/DynamicInput";
import EditableImg from "../../../components/forms/EditableImg";

export default function AddProgramModal({isOpen, close, theme, save, showSuccess}) {
   const saveCourse = e => {
      e.preventDefault();
      const formda = e.target;
      let newUser = {};
      console.log(formda);
      save(newUser);
   };

   return (
      <Modal
         isOpen={isOpen}
         close={() => {
            close();
         }}
         theme={theme}
         showSuccess={showSuccess}
         title="Nuevo programa emblem"
         size="big"
      >
         <DivModal>
            <form onSubmit={saveCourse}>
               <Grid>
                  <Col large={4}>
                     <Input type="text" placeholder="Nombre del curso" name="name" />
                  </Col>
                  <Col large={3} />
                  <Col large={2}>
                     <SelectStyled defaultValue={0}>
                        <option value={0}>Total de horas</option>
                        <option value={1}>1</option>
                     </SelectStyled>
                  </Col>
                  <Col large={0.5} />
                  <Col large={2.5}>
                     <Input type="date" placeholder="Código del certificado" name="code" />
                  </Col>
               </Grid>

               <Grid>
                  <Col large={6}>
                     <Grid>
                        <Col large={12}>
                           <Label>Descripción corta:</Label>
                        </Col>
                        <Col large={12}>
                           <TextArea as="textarea" placeholder="Texto"></TextArea>
                        </Col>
                     </Grid>
                  </Col>
                  <Col large={7} className="maxMargin">
                     <EditableImg editable={true} label="Medidas aprox: 394px X 317px" value="" name="newEmblemImg" />
                  </Col>
               </Grid>
               <Grid>
                  <Col large={2} offsetL={10}>
                     <AppButton>Guardar</AppButton>
                  </Col>
               </Grid>
            </form>
         </DivModal>
      </Modal>
   );
}

const DivModal = styled.div`
   .buttonModal {
      margin-top: 2em;
   }
   .maxMargin {
      margin-top: 2em;
   }
`;
/* 
const LineGrid = styled(Grid)`
   align-items: center;
`; */
